// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>18</span>&nbsp;&nbsp;Blessed be the Lord who bears our burdens day by day,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for God is our salvation.<br> </p> </div></div>";
// Exports
module.exports = code;